import { useIoTHubConnectorList } from './useIoTHubConnectorList'

export function useIoTHubConnector({ clientId }: { clientId: string }) {
  const { list, refetch } = useIoTHubConnectorList()

  return { connector: list.find(x => x.clientId === clientId) || null, refetch }
}
